export default __webpack_public_path__ + "static/media/grid.002.f9323972.jpeg";